export default {"src":"/_next/static/media/carWithMagifyingGlassPlayground4LightBg_104.a6c47085.svg","height":104,"width":104,"blurWidth":0,"blurHeight":0};